import { apiCall } from "./Interceptor";

const GENERATOR_PLANT_DETAILS = "/generator-plant/get";
const PLANT_DETAILS_CREATE = "/generator-plant/create";

const createGenerator = async (data) => {
 const response = await apiCall.post(PLANT_DETAILS_CREATE, data);
 return response;
};
const getPlantDetails = async (id) => {
 let url = GENERATOR_PLANT_DETAILS;

 if (id) {
  url += `?id=${id}`;
 }

 const response = await apiCall.get(url);
 return response;
};

export default {
 getPlantDetails,
 createGenerator,
};
